// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"592":"f1b86c46","787":"c1112931","976":"a5d0e978"}[chunkId] + ".chunk.js";
};